<app-elevation-section [title]="languageService.LNG('Label.Articles')" [removeMargin]="allowEdit" [removePadding]="true">
    <dx-data-grid
      #datagriddx
      class="pointer"
      [dataSource]="articles"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [columnAutoWidth]="true"
      (onEditorPreparing)="onEditorPreparing($event)"
      (onEditingStart)="onEditingStart($event)"
      (onSaving)="onSavingMultiple($event)"
      (onInitNewRow)="onInitNewRow($event)"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      height="{{ allowEdit ? 185 : 140 }}">

      <dxo-editing
        mode="batch"
        [allowUpdating]="allowEdit"
        [allowAdding]="allowEdit"
        [useIcons]="true">
      </dxo-editing>

      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-selection mode="multiple" showCheckBoxesMode="always"> </dxo-selection>

      <dxi-column
        dataField="TransportArticleId"
        caption="{{ languageService.LNG('Label.Articles') }}">
        <dxo-lookup
          [dataSource]="articleTypes"
          valueExpr="TransportArticleId"
          displayExpr='DisplayName'>
        </dxo-lookup>
      </dxi-column>

      <dxi-column
        dataField="NumberOfTrips"
        caption="{{ languageService.LNG('Label.Trips') }}"
        dataType="number"
        width="70">
      </dxi-column>

      <dxi-column
        dataField="Quantity"
        caption="{{ languageService.LNG('Label.Quantity') }}"
        dataType="number"
        width="90">
      </dxi-column>

      <dxi-column
        dataField="TransportQuantityUnitCode"
        caption="{{ languageService.LNG('Label.Unit') }}"
        width="70"
        [allowEditing]="false">
      </dxi-column>

    </dx-data-grid>
  </app-elevation-section>
